<template>
  <div class="main">
    <div class="title-info">
      <div style="display: flex;align-items: center;">
        <van-image width="40" height="40" round :src="form.Avatar"/>
        <div style="padding-left:12px;">
          <div>{{form.Name}}</div>
          <a>{{form.Phone}}</a>
          <van-icon name="edit" size="18" color="#999999" style="padding-left:8px;" @click="goto('home/routeSet?type=phone')"/>
        </div>
      </div>
      <div @click="changeRole">
        <a>切换身份：</a>
        <a style="color:#FEB013;font-weight: bold;">{{RoleText}}</a>
      </div>
    </div>
    <div class="title-car" v-show="Role === 'driver'">
      <div style="display:flex;justify-content: space-between;">
        <div>车辆信息<a class="title-btn">实名认证</a></div>
        <div style="color:#39A0F4;" @click="goto('home/routeSet?type=car')">编辑</div>        
      </div>
      <div>{{form.CarNum}}({{form.CarColor+form.CarBrand+form.CarName}} | {{form.CarSeat}}座)</div>
    </div>
    <div class="title-set">
      <div class="car-list" style="border-right: 1px solid #D2D2D2;" @click="goto('home/record')">
        <van-image width="28" height="28" :src="require('../../assets/record.svg')"/>
        <div style="padding-left:12px;">
          <div>拼车记录</div>
          <div class="car-remark">记录详情</div>
        </div>
      </div>
      <div class="car-list" @click="routeSet()">
        <van-image width="28" height="28" :src="require('../../assets/set.svg')"/>
        <div style="padding-left:12px;">
          <div>路线设置</div>
          <div class="car-remark">常用路线</div>
        </div>
      </div>
    </div>
    <div class="cell" @click="goto('work/audit')" v-if="Role === 'driver'">
      <a><van-icon name="coupon-o" style="padding-right:8px;"/>申请审核</a>
      <van-icon name="arrow" color="#999999"/>
    </div>
    <div class="cell" @click="goto('home/abnormal')" v-if="Role === 'passenger'">
      <a><van-icon name="envelop-o" style="padding-right:8px;"/>异常提交</a>
      <van-icon name="arrow" color="#999999"/>
    </div>
    <div class="cell" @click="goto('home/feedback')">
      <a><van-icon name="records" style="padding-right:8px;"/>意见反馈</a>
      <van-icon name="arrow" color="#999999"/>
    </div>
    <div class="cell" @click="goto('home/guide')">
      <a><van-icon name="comment-o" style="padding-right:8px;"/>用户指南</a>
      <van-icon name="arrow" color="#999999"/>
    </div>
    <!-- <div class="cell" @click="goto('home/report')" v-if="Role === 'driver'">
      <a><van-icon name="bar-chart-o" style="padding-right:8px;"/>下班拼车统计</a>
      <van-icon name="arrow" color="#999999"/>
    </div> -->
    <div class="cell" @click="goto('home/account')" v-if="Role === 'driver'">
      <a><van-icon name="bill-o" style="padding-right:8px;"/>月度核算</a>
      <van-icon name="arrow" color="#999999"/>
    </div>
    <div class="company">由营销信息部提供技术支持</div>
    <van-popup
      v-model="showRole"
      closeable
      round
      position="bottom"
      :close-on-click-overlay="false"
      style="height:250px;">
      <div class="popup-title">请选择切换身份</div>
      <van-radio-group v-model="Role" style="margin:0 16px;">
        <div
          class="popup-radio-box"
          @click="checkRadio('passenger')"
          :style="Role === 'passenger' ? 'background: rgba(254, 176, 19, 0.1);': ''">
          <div>
            <div style="font-weight: bold;">我是乘客</div>
            <div style="color: #999999;font-size:12px;">寻找顺路司机，高效通勤</div>
          </div>
          <van-radio name="passenger" checked-color="#FEB013"/>
        </div>
        <div
          class="popup-radio-box"
          @click="checkRadio('driver')"
          :style="Role === 'driver' ? 'background: rgba(254, 176, 19, 0.1);': ''">
          <div>
            <div style="font-weight: bold;">我是司机</div>
            <div style="color: #999999;font-size:12px;">寻找顺路乘客，公司补贴油费</div>
          </div>
          <van-radio v-if="haveRoute" name="driver" checked-color="#FEB013"/>            
          <a v-else class="approve">去认证</a>
        </div>
      </van-radio-group>
    </van-popup>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showRole: false,
      Role: 'passenger',
      RoleText: '乘客',
      form: {},
      roleBtn: false,
      haveRoute: false
    }
  },
  mounted() {
    // const test = {"errno":0,"data":{"area":"健树","errcode":0,"errmsg":"ok","userid":"201755100","name":"吴昌悦","department":[2267],"position":"软件开发工程师","mobile":"15812615614","gender":"1","email":"wuchangyue@jianlianmed.com","avatar":"http://wework.qpic.cn/wwhead/duc2TvpEgSTPk74IwG7Bs6QbDoJ0d3L4YVkyYficZxxcflGOZ1LUI81OkNwXIicNlbdduibhLKxSGc/0","status":1,"isleader":0,"extattr":{"attrs":[{"name":"英文名","value":"","type":0,"text":{"value":""}},{"name":"工号","value":"2017551","type":0,"text":{"value":"2017551"}},{"name":"身份证","value":"","type":0,"text":{"value":""}}]},"english_name":"","telephone":"020-88985632","enable":1,"hide_mobile":0,"order":[0],"external_profile":{"external_attr":[],"external_corp_name":""},"main_department":2267,"qr_code":"https://open.work.weixin.qq.com/wwopen/userQRCode?vcode=vc5b6c10860443246c","alias":"","is_leader_in_dept":[0],"address":"","thumb_avatar":"http://wework.qpic.cn/wwhead/duc2TvpEgSTPk74IwG7Bs6QbDoJ0d3L4YVkyYficZxxcflGOZ1LUI81OkNwXIicNlbdduibhLKxSGc/100","direct_leader":[],"openid":"o_Td1s7gCLuLiZITNxC3ApjOLC7U","access_token":"hER4OJaZReJSc_9Mi6NCJTXyliK2QkEDuj0ruK4CsiFGKySTq81qK6AsR7GqX6bROcq28TctrjQqtXheO0mKenvkX6pu6kkuP9cSO51qDnBHwnOThgl4thnSeAFw_PlA0aUdAX3tE5yPHs3IIgOwB4bEc6yFKchMe7tjjaACla90dBlIe8j8JuSB-SOLpoWVXMI36ulQW7uRs6VXRfH57w"}}
    // this.WXInfo = test.data
    this.WXInfo = JSON.parse(localStorage.getItem('userinfo')).data
    this.Role = localStorage.getItem('Role') ? localStorage.getItem('Role') : null
    this.getUserInfo(this.WXInfo.userid)
    if (this.Role === 'passenger') {
      this.getPassengerInfo()
    } else {
      this.getDriverTravel()
    }
    
  },
  methods: {
    routeSet () {
      if (this.Role === 'driver') {
        this.goto('home/routeSet?type=route')
      } else {
        this.$toast('当前角色为乘客，无法编辑路线。')
      }
    },
    goto(name) {
      this.$router.push('/'+ name)
    },
    changeRole () {
      if (this.roleBtn) {
        this.$dialog.alert({ message: '当前存在订单记录无法更改角色，请取消订单或次日再变更角色' })
      } else {
        this.showRole = true
      }
    },
    async checkRadio(val) {
      // 当前角色与选择的角色一致，直接关闭弹窗
      if (this.Role === val) {
        this.showRole = false
      } else {
        localStorage.setItem('Role', val)
        this.Role = val
        this.RoleText = val === 'passenger'?'乘客': '司机'
        if (this.haveRoute) {
          const result = await this.postUserCarData({ Role: val })
          if (result.success) {
            this.$toast('您已切换为'+this.RoleText+'角色')
            this.showRole = false
          }
        } else {
          this.goto('login?role=driver&register=true')
        }        
      }
    },
    // 查询用户基础数据
    async getUserInfo(data) {
      const result = await this.$request({
        url: this.$api.getUserInfo,
        method: 'GET',
        params: {
          UserId: data
        }
      })
      if (result.data.length > 0) {
        this.form = result.data[0]
        this.Role = this.form.Role
        localStorage.setItem('Role', this.Role)
        this.RoleText = this.form.Role === 'passenger'?'乘客': '司机'
        this.haveRoute = this.form.routerInfo.length > 0
      } else {
        this.$toast(result.message)
      }
    },
    // 角色为司机 查询司机当天拼车信息
    async getDriverTravel() {
      const result = await this.$request({
        url: this.$api.getAllRouteList,
        method: 'GET',
        params: {
          UserId: this.WXInfo.userid,
          DateTime: this.$moment(new Date()).format('YYYY-MM-DD')
        }
      })
      if (result.data.length > 0 && result.data[0].Status !== '已取消') {
        this.roleBtn = true
      }
    },
    // 角色为乘客 查询乘客当天拼车信息
    async getPassengerInfo() {
      const result = await this.$request({
        url: this.$api.getPassengerByOpenid,
        method: 'GET',
        params: {
          UserId: this.WXInfo.userid,
          DateTime: this.$moment().format('YYYY-MM-DD')
        }
      })
      if (result.success) {
        this.roleBtn = true
      }
    },
    // 新增/更新用户基础数据
    postUserCarData(data) {
      return this.$request({
        url: this.$api.postUserCar,
        method: 'POST',
        params: {
          UserId: this.WXInfo.userid
        },
        data: Object.assign({ UserId: this.WXInfo.userid }, data)
      })
    },    
  }
}
</script>

<style lang="less" scoped>
/deep/.van-radio__icon .van-icon {
  border: initial;
}
.main {
  background-color:#FFFFFF;
  padding: 12px 12px 0 12px;
}
.title-info {
  font-size: 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  line-height: 1.5;
}
.title-car {
  background-color: #C2E2FC;
  border-radius: 4px;
  padding: 8px 12px;
  margin-top: 16px;
  line-height: 2;
}
.title-btn {
  background-color: #39A0F4;
  color: #FFFFFF;
  border-radius: 10px;
  padding: 4px 8px;
  font-size: 12px;
  margin-left: 8px;
}
.title-set {
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  padding: 13px 0;
  display: flex;
  line-height: 1.5;
  margin: 15px 0 25px 0;
}
.car-list {
  display: flex;
  align-items: center;
  width: 50%;
  padding-left: 36px;
}
.car-remark {
  color: #999999;
  font-size: 12px;
}
.cell {
  padding:16px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #d2d2d247;
}
.popup-title {
  text-align: center;
  padding: 16px;
}
.popup-radio-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  line-height: 1.5;
  border-radius: 4px;
  background: #F5F5F5;
  padding: 12px;
  margin: 8px 0;
}
.approve {
  color:#F22222;
  text-decoration-line: underline;
  font-weight: 600;
}
.company {
  position: relative;
  bottom: -70px;
  text-align: center;
  color: #999999;
  font-size: 12px;
  margin-bottom: 10px;
}
</style>
